<form
  class="page-content overflow-y-auto flex flex-col items-center justify-center"
  [formGroup]="form"
  (submit)="onSubmit()"
>
  <fieldset class="bm-fieldset border rounded border-base-300 bg-base-100 p-4 w-full max-w-96">
    <legend class="bm-fieldset-legend text-lg">Login</legend>
    <label for="email" class="bm-fieldset-label">E-Mail</label>
    <input
      type="email"
      class="bm-input w-full"
      id="email"
      [formControl]="form.controls.email"
      placeholder="E-Mail-Adresse"
    />
    <label for="password" class="bm-fieldset-label">Passwort</label>
    <input
      type="password"
      class="bm-input w-full"
      id="password"
      [formControl]="form.controls.password"
      placeholder="Passwort"
    />
    <button type="submit" class="bm-btn bm-btn-block bm-btn-primary mt-4">Login</button>

    @if (error(); as text) {
      <div class="bm-alert bm-alert-error bm-alert-dash mt-4 w-full">{{ text }}</div>
    }
  </fieldset>
</form>
